<template>
  <div>
    <detailsGroupe
      v-if="projet"
      :idGroupe="$route.params.id"
      :projet="projet[0]"
    />
    <Navigation v-if="isSuperviseur" :elements="SuperviseurNavigation" />
    <Navigation v-if="isAdmin" :elements="AdminNavigation" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.SetItemById(this.$route.params.id);
    this.GetMembresDuGroupe(this.$route.params.id);
  },
  components: {
    etapesEffectives: require("@/components/groupes/etapesEffectives.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
    detailsGroupe: require("@/components/groupes/detailsGroupe").default,
  },
  methods: {
    ...mapActions({
      SetItemById: "Groupes/SetItemById",
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
    }),
  },
  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      GroupeNavigation: (state) => state.Navigation.GroupeNavigation,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      isSuperAdmin: (state) => state.Auth.isSuperAdmin,
      isAdmin: (state) => state.Auth.isAdmin,
      isSuperviseur: (state) => state.Auth.isSuperviseur,
      isGroupe: (state) => state.Auth.isGroupe,
      user: (state) => state.Auth.user,
      projets: (state) => state.Projets.projets,
      projet: function (state) {
        return _.filter(state.Projets.projets, {
          id: this.$route.query.projet,
        });
      },
    }),
  },
};
</script>
<style scoped></style>
